'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024111 from "./presto.-Presto-Router$$anon$111.js";
import * as $j_presto$002e$002dUnknown$002dPage$0024 from "./presto.-Unknown-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$110() {
  this.ben = null;
  this.bef = null;
  this.beg = false;
  this.beo = null;
  this.bep = false;
  this.bes = null;
  this.bel = null;
  this.bem = false;
  this.beh = null;
  this.bei = false;
  this.bej = null;
  this.bek = false;
  this.beq = false;
  this.ber = false;
  this.ben = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bes = "UnknownPage";
}
export { $c_Lpresto_PrestoRouter$$anon$110 as $c_Lpresto_PrestoRouter$$anon$110 };
$p = $c_Lpresto_PrestoRouter$$anon$110.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$110;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$110() {
}
export { $h_Lpresto_PrestoRouter$$anon$110 as $h_Lpresto_PrestoRouter$$anon$110 };
$h_Lpresto_PrestoRouter$$anon$110.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.ben;
});
$p.L = (function() {
  if ((!this.beg)) {
    this.bef = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.beg = true;
  }
  return this.bef;
});
$p.O = (function() {
  if ((!this.bep)) {
    this.beo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bep = true;
  }
  return this.beo;
});
$p.E = (function() {
  return this.bes;
});
$p.t = (function() {
  if ((!this.bem)) {
    this.bel = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("str", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bem = true;
  }
  return this.bel;
});
$p.M = (function() {
  if ((!this.bei)) {
    this.beh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bei = true;
  }
  return this.beh;
});
$p.Q = (function() {
  if ((!this.bek)) {
    this.bej = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024111.$c_Lpresto_PrestoRouter$$anon$111();
    this.bek = true;
  }
  return this.bej;
});
$p.w = (function() {
  if ((!this.ber)) {
    this.beq = false;
    this.ber = true;
  }
  return this.beq;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee658) => ((p) => \u03b4scrutinee658.cGb(p)))($j_presto$002e$002dUnknown$002dPage$0024.$m_Lpresto_UnknownPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$110 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$110, "presto.PrestoRouter$$anon$110", ({
  Ny: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$110 as $d_Lpresto_PrestoRouter$$anon$110 };
//# sourceMappingURL=presto.-Presto-Router$$anon$110.js.map
